import React, { useContext, useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { GlobalState } from '../../GlobalState';
import PaypalButton from '../../components/mainpages/cart/PaypalButton';
import axios from 'axios';
import { TikTok } from "react-tiktok";
import Cardhub from '../../components/mainpages/utiliscontenthub/Conthubcard'


function Detailcontent() {
    const params = useParams();
    const state = useContext(GlobalState);
    const [products] = state.productsAPI.products || [[]];
    const { id } = useParams()

    const [detailProduct, setDetailProduct] = useState(null); // Cambié el estado inicial a `null`
    const [paidDescription, setPaidDescription] = useState(null);
    const [error, setError] = useState(null);
    const [paymentSuccessful, setPaymentSuccessful] = useState(false);
    const [detailadd, setDetaiadd] = useState({});

    const [isLoading, setIsLoading] = useState(true); // Estado para controlar la carga

    // Extraer datos del producto
    useEffect(() => {
        if (params.id && products.length > 0) {
            const selectedProduct = products.find(product => product._id === params.id);
            if (selectedProduct) {
                setDetailProduct(selectedProduct);

                //console.log('paidByUser:', selectedProduct.paidByUser);  // Para verificar que está recibiendo el valor correctamente
                // Verificar si el usuario actual ya está en la lista de `paidByUser`
                const userHasPaid = selectedProduct.paidByUser.includes(id); // Comparar ID del usuario
                if (userHasPaid) {
                    setPaidDescription(selectedProduct.description); // Mostrar la descripción completa
                    setDetaiadd({
                        urlsmovies: selectedProduct.urlsmovies || [],
                        arrayimages: selectedProduct.arrayimages || [],
                    });
                    setError(null); // Limpia cualquier mensaje de error
                } else {
                    setError("No puede ver todo el contenido de este perfil.");
                }

            } else {
                console.warn("Producto no encontrado");
                setDetailProduct(null); // Manejar el caso de un producto no encontrado
            }
        }
    }, [params.id, products]);
    // Implementación de PayPal
    useEffect(() => {
        const checkIfPaid = async () => {
            setIsLoading(true); // Inicia el estado de carga
            try {
                const res = await axios.get(`/api/products/${params.id}/checkPaid`, {
                    headers: { Authorization: state.token[0] }
                });
                if (res.data.paid) {
                    // Si el usuario ya pagó, se muestra la descripción completa
                    setPaidDescription(detailProduct.description);
                    setDetaiadd(prev => ({
                        ...prev,
                        urlsmovies: res.data.urlsmovies,
                        arrayimages: res.data.arrayimages,
                        videos: res.data.videos
                    }));
                    setError(null);
                } else {
                    // Si no ha pagado, muestra el mensaje de error
                    setError("No puede ver todo el contenido de este perfil.");
                }
            } catch (error) {
                setError("Todavia no tiene acceso a todo el contenido.");
            } finally {
                setIsLoading(false); // Finaliza el estado de carga
            }
        };

        if (detailProduct && detailProduct._id) {
            checkIfPaid();
        }
    }, [detailProduct, state.token, params.id]);

    const tranSuccess = async (paymentDetails) => {
        try {
            const res = await axios.post('/api/payment', {
                productId: detailProduct._id,
                paymentID: paymentDetails.id,
                address: paymentDetails.payer.address
            }, {
                headers: { Authorization: state.token[0] }
            });

            setPaymentSuccessful(true);
            setError(null);
            setPaidDescription(detailProduct.description);  // Actualiza para mostrar la descripción completa
            setDetaiadd(prev => ({
                ...prev,
                urlsmovies: res.data.urlsmovies,
                arrayimages: res.data.arrayimages
            })); // Incluye los nuevos campos
        } catch (err) {
            setError("Hubo un problema al registrar el pago.");
        }
    };

    ////zoom en la imagen
    const [selectedImage, setSelectedImage] = useState(null);
    const [zoomLevel, setZoomLevel] = useState(1);

    const openImage = (image) => {
        setSelectedImage(image);
        setZoomLevel(1);
    };

    const closeImage = () => {
        setSelectedImage(null);
    };

    const handleZoom = (direction) => {
        setZoomLevel((prevZoom) => Math.max(0.5, prevZoom + direction));
    };

    //

    // Verificar si el precio está disponible antes de mostrar el botón
    const isPriceValid = detailProduct && !isNaN(detailProduct.price) && detailProduct?.price > 0;

    return (
        <div className='content_detail_hubmovie' >
            <div class="">
                <section class="member-details">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-3 col-md-4">
                                <div class="img-container">
                                    <img src={detailProduct.images.url} alt="team member" class="img-full" />
                                </div>
                            </div>
                            <div class="col-lg-9 col-md-8">
                                <div class="member_designation">
                                    <h2><i class="fa-solid fa-star"></i> {detailProduct.title}</h2>
                                    <span>
                                        <Link>
                                            <i class="fa-solid fa-arrow-up-right-from-square"></i> {detailProduct.nombre}
                                        </Link>
                                    </span>
                                </div>
                                <div class="member_desc">
                                    <p>
                                        {detailProduct.content}
                                    </p>
                                    <ul class="styled_list">
                                        <li class=""><i class="fa fa-chevron-circle-right" aria-hidden="true"></i> {detailProduct.nombre}</li>
                                    </ul>
                                </div>
                                <div class="bg-image ">
                                    {/*<img src={detailProduct.images.url} atl='' />*/}
                                    <img src={detailProduct.urluno} atl='' />
                                    <div class="member_contact">
                                        <div class="row">
                                            <div class="col-lg-4  mb-3 mb-lg-0">
                                                <div class="media-box">
                                                    <div class="media-icon">
                                                        <i class="fa-solid fa-user"></i>
                                                    </div>
                                                    <div class="media-content">
                                                        <h5>Perfil</h5>
                                                        <p><a href="callto">(+1) 251-235-3256</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4  mb-3 mb-lg-0">
                                                <div class="media-box">
                                                    <div class="media-icon">
                                                        <i class="fa fa-envelope-o" aria-hidden="true"></i>
                                                    </div>
                                                    <div class="media-content">
                                                        <h5>Email</h5>
                                                        <p><a href="mailto">info@example.com</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <div class="social-icons">
                                                    <button class="btn btn-social outlined"><i class="fa-brands fa-facebook"></i></button>
                                                    <button class="btn btn-social outlined"><i class="fa-brands fa-instagram"></i></button>
                                                    <button class="btn btn-social outlined"><i class="fa-brands fa-tiktok"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <h2 className='vid_tiktok_title'>Videos Populares</h2>

            <div className='content_tiktok_vid'>
                {Array.isArray(detailProduct.urltiktoks) && detailProduct.urltiktoks.length > 0 ? (
                    detailProduct.urltiktoks.map((vid, index) => (
                        <div key={index}>
                            <TikTok url={vid} />
                        </div>
                    ))
                ) : (
                    <p>No hay tiktoks disponibles</p>
                )}
            </div>

            <div>
                <div className="gallery-container">
                    {/* Sección de Imágenes */}
                    <div className="image-gallery">
                        {detailProduct?.arrayimagesfakes?.map((img, index) => (
                            <div
                                key={`img-${index}`}
                                className="gallery-item"
                                onClick={() => openImage(img.url)}
                            >
                                <img src={img.url} alt={`Image ${index}`} />
                            </div>
                        ))}
                    </div>
                    {/* Sección de Videos */}
                    <div className="video-gallery">
                        {detailProduct?.urlsmoviesfakes?.map((video, index) => (
                            <div key={`video-${index}`} className="video-container">
                                <video src={video} controls />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {selectedImage && (
                <div className="custom-image-viewer" onClick={closeImage}>
                    <div
                        className="custom-image-viewer-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <img
                            src={selectedImage}
                            alt="Selected"
                            style={{ transform: `scale(${zoomLevel})` }}
                        />
                        <div className="custom-image-controls">
                            <button onClick={() => handleZoom(0.2)}>+</button>
                            <button onClick={() => handleZoom(-0.2)}>-</button>
                            <button onClick={closeImage}>Cerrar</button>
                        </div>
                    </div>
                </div>
            )}






            {
                isLoading ? (
                    <p>Cargando detalles del producto...</p>
                ) : (
                    <>
                        {!paidDescription && isPriceValid && (
                            <div className="paypal-button-container">
                                <PaypalButton total={detailProduct.price} tranSuccess={tranSuccess} />
                            </div>
                        )}
                    </>
                )
            }
            {!isPriceValid && (
                <div className="error-message">El precio no está disponible o es inválido.</div>
            )}






            {detailProduct ? (
                <div>

                </div>
            ) : (
                <p>Producto no encontrado</p>
            )}

            <div>
                <h2 className='conten_relacion_detailhub'>Contenido Relacionado</h2>
                <div className="products">
                    {
                        products.map(product => {
                            return product.category === detailProduct.category
                                ? <Cardhub key={product._id} product={product} /> : null
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default Detailcontent;